import { createContext, useContext, useState, type ReactNode } from 'react'

/**
 * Tiny shared signal so the Layout can hide the progress step list while
 * the marketing intro graphic is on screen. ScreenHome flips this off the
 * moment the user clicks "Get started" — that's when they enter step 1
 * (Address), so the chrome needs to appear.
 *
 * Default is `true` so the step list stays hidden during the first render
 * at `/` (before ScreenHome's effect has fired), avoiding a flash of the
 * progress chrome behind the intro.
 */
type IntroVisibilityCtx = {
  introVisible: boolean
  setIntroVisible: (visible: boolean) => void
}

const Ctx = createContext<IntroVisibilityCtx>({
  introVisible: true,
  setIntroVisible: () => {},
})

export function IntroVisibilityProvider({ children }: { children: ReactNode }) {
  const [introVisible, setIntroVisible] = useState(true)
  return (
    <Ctx.Provider value={{ introVisible, setIntroVisible }}>
      {children}
    </Ctx.Provider>
  )
}

export function useIntroVisibility(): IntroVisibilityCtx {
  return useContext(Ctx)
}
